var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-auto"},[_c('v-loading-cancel-button',{attrs:{"loading":_vm.loading,"x-small":true},on:{"clicked":function($event){return _vm.$emit('clicked', {row: _vm.row, link: _vm.link})}}},[_c('i',{staticClass:"fas fa-copy text-sm"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }